import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { PrincipalService } from '@app/principal/service/principal.service';
import { ButtonComponent } from '@app/shared/button/button.component';
import { MessageComponent } from '@app/shared/message/message.component';
import { PrivacyPolicyComponent } from '@modules/sign-in/components/sign-up/components/password-setup-state/components/privacy-policy/privacy-policy.component';
import { UserAgreementComponent } from '@modules/sign-in/components/sign-up/components/password-setup-state/components/user-agreement/user-agreement.component';
import { RegisterUserBody } from '@modules/sign-in/components/sign-up/components/password-setup-state/password-setup-api.model';
import { RegisterUserService } from '@modules/sign-in/components/sign-up/components/password-setup-state/register-user.service';
import { NgxMaskModule } from 'ngx-mask';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { TypeStep } from '../sign-up.component';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
  standalone: true,
  imports: [ButtonComponent, CommonModule, ReactiveFormsModule, NgxMaskModule, MessageComponent],
})
export class RegistrationComponent implements OnInit {
  registrationForm: FormGroup;
  isShowPassword = false;
  isShowConfirmPassword = false;
  registerUserOperation$: Observable<void>;
  registerUserOperationInFly$: Observable<boolean>;
  @Input() login: string;
  @Input() token: string;

  @Output() changeStep = new EventEmitter<TypeStep>();
  constructor(
    private _dialogService: DialogService,
    private _registerUserService: RegisterUserService,
    private principalService: PrincipalService,
  ) {}
  ngOnInit(): void {
    this.registrationForm = new FormGroup(
      {
        name: new FormControl<string>(null, [Validators.required]),
        password: new FormControl<string>(null, [Validators.required]),
        confirmPassword: new FormControl<string>(null, [Validators.required]),
        toc: new FormControl<boolean>(false, [Validators.requiredTrue]),
      },
      { validators: this.checkPassword as ValidatorFn },
    );

    this.registerUserOperation$ = this._registerUserService.registerUser$.pipe(
      tap((profile: any) => this.principalService.setCurrentUser(profile)),
      tap((res: any) => res && this.changeStep.emit('closeAll')),
      map(() => void 0),
    );

    this.registerUserOperationInFly$ = this._registerUserService.registerUserOperationInFly$;
  }

  openUserAgreement() {
    this._dialogService.open(UserAgreementComponent, {
      showHeader: true,
    });
  }

  openPrivacyPolicy(): void {
    this._dialogService.open(PrivacyPolicyComponent, {
      showHeader: true,
    });
  }

  checkPassword(control: AbstractControl): { [key: string]: boolean } | null {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;

    return password === confirmPassword ? null : { passwordsMismatch: true };
  }

  private get registerUserPayload(): RegisterUserBody {
    const { name, password, toc: sign } = this.registrationForm.value;
    return {
      name,
      password,
      sign,
    };
  }

  registerUser() {
    this._registerUserService.registerUser({ token: this.token, login: this.login, body: this.registerUserPayload });
  }
}
